export const formLabelClass = 'block text-preset-5 font-medium text-gray-700';
export const formInputClass =
  'appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-preset-5';
export const primaryButtonClass =
  'w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-preset-6 font-medium text-white bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary';
